/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { FaCss3Alt, FaHtml5, FaNodeJs, FaReact, FaSass } from 'react-icons/fa';
import { IoLogoJavascript } from 'react-icons/io';
import { SiFirebase, SiHeroku, SiMongodb, SiNetlify, SiNpm, SiRedux } from 'react-icons/si';
import { Fade } from 'react-reveal';
import { Col, Container, Row } from 'reactstrap';
import webdev from '../assets/lottie/webdev.json';
import DisplayLottie from '../components/DisplayLottie';
import { skillsSection } from '../portfolio';

const Skills = () => (
  <Fade left duration={1000} distance="40px">
    <Container className="text-center my-5 section section-lg">
      <h1 className="h1">{skillsSection.title}</h1>
      <p className="lead">{skillsSection.subTitle}</p>
      <Row>
        <Col lg="6">
          <DisplayLottie animationData={webdev} />
        </Col>
        <Col lg="6">
          <>
            <div className="d-flex justify-content-center flex-wrap mb-5">
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <FaHtml5 />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <FaCss3Alt />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <FaSass />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <IoLogoJavascript />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <FaNodeJs />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <FaReact />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiRedux />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiFirebase />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiHeroku />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiNetlify />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiMongodb />
              </div>
              <div className="icon icon-lg icon-shape shadow rounded-circle mb-5">
                <SiNpm />
              </div>
            </div>
          </>

          <div>
            {skillsSection.skills.map((skill) => (
              <p key={skill}>{skill}</p>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  </Fade>
);

export default Skills;
